export default __webpack_public_path__ + "static/Regis-f055bd689899b1f9b3c9ddcf6cde4ec3.png";